import { useState } from "react";
import { Button, CircularProgress, Typography } from "@mui/material";
import { useMutation } from 'react-query'
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { remove } from "../services/api";

export default function Remove({ open, close, instance, reportAction }) {
  const [isLoading, setIsLoading] = useState(false)

  const mutation = useMutation(remove, {
    onSuccess: (data) => {
      setIsLoading(false)
      if(data.status === "error") { reportAction(false, 'Error al guardar los datos', 'error')
      } else { reportAction(true, 'Acción realizada correctamente', 'success') }
    }
  })

  const handleRemove = () => { 
    setIsLoading(true)
    mutation.mutate(instance._id)
  }

  const handleClose = () => { close() }

  const Actions = () => (<>
    { !isLoading ? <>
      <Button onClick={handleClose}>Cancel</Button>
      <Button variant="contained" color="error" onClick={ () => handleRemove() }>Eliminar</Button>
      </> : <CircularProgress /> }
  </>)

  return (
    <FlexibleWidthDialog open={open} title="Eliminar categoría" actions={<Actions />}>
      <Typography variant="body1" component="p">
        ¿Estas seguro de quere eliminar la categoría <b>{instance.name}</b>?
      </Typography>
    </FlexibleWidthDialog>
  )
}